// SupabaseStorageAdapter: cross-device save progress.
// Implements the same get/set/remove(key) contract as the local adapter, so the
// StorageManager (envelopes, mirroring, migrations) works unchanged.
//
// Rows are keyed by (player_id, key); key already carries the game namespace
// (bf:<gameId>:<key>) from StorageManager. game_id is stored for filtering.
// Requires the `saves` table from SUPABASE_SETUP.md.

export class SupabaseStorageAdapter {
  constructor(backend, gameId) {
    this.backend = backend;
    this.gameId = gameId;
  }

  _c() {
    if (!this.backend?.ready || !this.backend.client) {
      throw new Error('Supabase backend not ready.');
    }
    return this.backend.client;
  }

  async get(key) {
    const { data, error } = await this._c()
      .from('saves')
      .select('value')
      .eq('player_id', this.backend.identity.playerId)
      .eq('key', key)
      .maybeSingle();
    if (error) throw error;
    return data ? data.value : null;
  }

  async set(key, value) {
    const { error } = await this._c()
      .from('saves')
      .upsert(
        {
          player_id: this.backend.identity.playerId,
          game_id: this.gameId,
          key,
          value,
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'player_id,key' }
      );
    if (error) throw error;
  }

  async remove(key) {
    const { error } = await this._c()
      .from('saves')
      .delete()
      .eq('player_id', this.backend.identity.playerId)
      .eq('key', key);
    if (error) throw error;
  }
}
